import React from "react";
import { Redirect, Route } from "react-router-dom";
import PublicLayout from "../layout/publicLayout";
import { useIsLoggedIn } from "hooks";

const PublicWrapper = ({ component: Component, ...rest }) => {
  const isLoggedIn = false;
  return (
    <Route
      {...rest}
      render={(props) =>
        isLoggedIn !== true ? (
          <PublicLayout {...props}>
            <Component {...props} />
          </PublicLayout>
        ) : (
          <Redirect
            to={{
              pathname: "/dashboard",
              state: { from: props.location },
            }}
          />
        )
      }
    />
  );
};

export default PublicWrapper;
